(function () {
  function money(cents) {
    if (typeof formatMoney === 'function' && window.theme && theme.settings) {
      return formatMoney(cents, theme.settings.money_with_currency_format);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function detailMatchesSection(element, event) {
    return event.detail && String(event.detail.sectionId) === String(element.dataset.sectionId);
  }

  if (!customElements.get('tile-unit-price')) {
    customElements.define('tile-unit-price', class TileUnitPrice extends HTMLElement {
      connectedCallback() {
        this.coverage = Number(this.dataset.coverage);
        this.price = Number(this.dataset.priceCents);
        this.compareAtPrice = Number(this.dataset.compareAtPriceCents);
        this.unitPrice = this.querySelector('[data-unit-price]');
        this.unitComparePrice = this.querySelector('[data-unit-compare-price]');
        this.onVariantRendered = this.onVariantRendered.bind(this);
        document.addEventListener('product:variant-rendered', this.onVariantRendered);
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('product:variant-rendered', this.onVariantRendered);
      }

      onVariantRendered(event) {
        if (!detailMatchesSection(this, event) || !event.detail.variant) return;
        this.price = Number(event.detail.variant.price);
        this.compareAtPrice = Number(event.detail.variant.compare_at_price || 0);
        this.render();
      }

      render() {
        if (!this.coverage || !this.unitPrice) return;
        this.unitPrice.innerHTML = money(Math.round(this.price / this.coverage)) + ' / sq. ft.';
        if (this.compareAtPrice > this.price) {
          this.unitComparePrice.innerHTML = money(Math.round(this.compareAtPrice / this.coverage)) + ' / sq. ft.';
          this.unitComparePrice.classList.remove('is-hidden');
        } else {
          this.unitComparePrice.classList.add('is-hidden');
        }
      }
    });
  }

  if (!customElements.get('tile-calculator')) {
    customElements.define('tile-calculator', class TileCalculator extends HTMLElement {
      connectedCallback() {
        this.coverage = Number(this.dataset.coverage);
        this.price = Number(this.dataset.priceCents);
        this.quantity = document.getElementById('Quantity-' + this.dataset.sectionId);
        this.areas = this.querySelector('[data-calculator-areas]');
        this.notice = this.querySelector('[data-calculator-notice]');
        this.onVariantRendered = this.onVariantRendered.bind(this);
        this.querySelector('[data-calculator-toggle]').addEventListener('click', (event) => this.toggle(event.currentTarget));
        this.querySelector('[data-add-area]').addEventListener('click', () => this.addArea());
        this.querySelector('[data-calculate]').addEventListener('click', () => this.calculate());
        this.querySelector('[data-add-waste]').addEventListener('change', () => this.calculate());
        this.areas.addEventListener('input', (event) => this.previewArea(event.target));
        if (this.quantity) this.quantity.addEventListener('change', () => this.renderSummary(Number(this.quantity.value)));
        const sampleButton = this.querySelector('[data-add-sample]');
        if (sampleButton) sampleButton.addEventListener('click', () => this.addSample(sampleButton));
        document.addEventListener('product:variant-rendered', this.onVariantRendered);
        this.renderSummary(this.getQuantity());
      }

      disconnectedCallback() {
        document.removeEventListener('product:variant-rendered', this.onVariantRendered);
      }

      toggle(button) {
        const panel = this.querySelector('[data-calculator-panel]');
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        button.lastElementChild.textContent = isOpen ? '+' : '-';
        panel.hidden = isOpen;
      }

      addArea() {
        const area = this.querySelector('[data-calculator-area]').cloneNode(true);
        area.querySelectorAll('input').forEach((input) => { input.value = ''; });
        area.querySelector('[data-area-result]').textContent = '0.00 sq. ft.';
        this.areas.appendChild(area);
      }

      previewArea(input) {
        const area = input.closest('[data-calculator-area]');
        if (!area) return;
        const width = Number(area.querySelector('[data-area-width]').value) || 0;
        const length = Number(area.querySelector('[data-area-length]').value) || 0;
        area.querySelector('[data-area-result]').textContent = (width * length).toFixed(2) + ' sq. ft.';
      }

      calculate() {
        const totalArea = Array.from(this.querySelectorAll('[data-calculator-area]')).reduce((total, area) => {
          const width = Number(area.querySelector('[data-area-width]').value) || 0;
          const length = Number(area.querySelector('[data-area-length]').value) || 0;
          return total + (width * length);
        }, 0);
        if (!totalArea || !this.coverage) {
          this.showNotice('Enter at least one width and length to calculate boxes.');
          return;
        }
        const withWaste = this.querySelector('[data-add-waste]').checked ? totalArea * 1.1 : totalArea;
        const boxes = this.normalizeQuantity(Math.ceil(withWaste / this.coverage));
        if (this.quantity) {
          this.quantity.value = boxes;
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.showNotice('');
        this.renderSummary(boxes);
      }

      normalizeQuantity(value) {
        if (!this.quantity) return Math.max(1, value);
        const minimum = Number(this.quantity.min) || 1;
        const step = Number(this.quantity.step) || 1;
        const adjusted = Math.max(minimum, value);
        return minimum + Math.ceil((adjusted - minimum) / step) * step;
      }

      getQuantity() {
        return this.quantity ? (Number(this.quantity.value) || 1) : 1;
      }

      renderSummary(quantity) {
        const boxCount = Math.max(1, Number(quantity) || 1);
        this.querySelector('[data-box-count]').textContent = boxCount;
        this.querySelector('[data-covered-area]').textContent = (boxCount * this.coverage).toFixed(2);
        this.querySelector('[data-total-price]').innerHTML = money(boxCount * this.price);
      }

      showNotice(message) {
        this.notice.textContent = message;
        this.notice.hidden = !message;
      }

      onVariantRendered(event) {
        if (!detailMatchesSection(this, event) || !event.detail.variant) return;
        this.price = Number(event.detail.variant.price);
        this.renderSummary(this.getQuantity());
      }

      addSample(button) {
        const id = button.dataset.sampleVariantId;
        if (!id || !window.theme) return;
        button.disabled = true;
        const data = new FormData();
        data.append('id', id);
        data.append('quantity', '1');
        fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: data
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw new Error(response.description || response.message);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart:item-added', { product: response });
            }
          })
          .catch((error) => this.showNotice(error.message || 'The sample could not be added to the cart.'))
          .finally(() => { button.disabled = false; });
      }
    });
  }
}());
